import { API } from '@/config/api';
import React, { useState, useEffect } from 'react';
import { Card } from '@/components/ui/card';
import { ExternalLink, MapPin } from 'lucide-react';


export default function Suppliers() {
  const [suppliers, setSuppliers] = useState([]);

  useEffect(() => {
    fetch(`${API}/suppliers`, { credentials: 'include' })
      .then(res => res.json())
      .then(setSuppliers)
      .catch(console.error);
  }, []);

  const ukSuppliers = suppliers.filter(s => s.region === 'UK');
  const overseasSuppliers = suppliers.filter(s => s.region === 'Overseas');

  return (
    <div className="p-4 md:p-8 max-w-7xl mx-auto" data-testid="suppliers-page">
      <h1 className="text-4xl font-bold mb-2">Suppliers Directory</h1>
      <p className="text-muted-foreground mb-8">Curated list of research peptide suppliers</p>

      <div className="space-y-8">
        <div>
          <h2 className="text-2xl font-bold mb-4 flex items-center">
            <MapPin className="h-6 w-6 mr-2 text-primary" /> UK Suppliers
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {ukSuppliers.map(s => (
              <Card key={s.supplier_id} className="p-6 glass-card">
                <h3 className="text-xl font-bold mb-2">{s.name}</h3>
                {s.url && (
                  <a href={s.url} target="_blank" rel="noopener noreferrer" className="flex items-center text-primary hover:underline text-sm mb-3">
                    <ExternalLink className="h-4 w-4 mr-1" /> Visit Website
                  </a>
                )}
                <p className="text-sm text-muted-foreground mb-2">{s.testing_notes}</p>
                <p className="text-xs text-muted-foreground">{s.shipping_info}</p>
              </Card>
            ))}
          </div>
        </div>

        <div>
          <h2 className="text-2xl font-bold mb-4 flex items-center">
            <MapPin className="h-6 w-6 mr-2 text-success" /> Overseas Suppliers
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {overseasSuppliers.map(s => (
              <Card key={s.supplier_id} className="p-6 glass-card">
                <h3 className="text-xl font-bold mb-2">{s.name}</h3>
                {s.url && (
                  <a href={s.url} target="_blank" rel="noopener noreferrer" className="flex items-center text-primary hover:underline text-sm mb-3">
                    <ExternalLink className="h-4 w-4 mr-1" /> Visit Website
                  </a>
                )}
                <p className="text-sm text-muted-foreground mb-2">{s.testing_notes}</p>
                <p className="text-xs text-muted-foreground">{s.shipping_info}</p>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
